import { blankToNull } from '../../../utils'

export function validate(record) {
  const errors = []

  if (!record.descricao) {
    errors.push({
      field: 'descricao',
      message: 'Descrição deve ser informada',
    })
  }

  if (!record.configuracaoBoleto) {
    errors.push({
      field: 'configuracaoBoleto',
      message: 'Configuração de boleto deve ser informada',
    })
  }

  blankToNull(record)
  const result = {
    ok: errors.length === 0,
    errors,
    record,
  }
  return new Promise((resolve, reject) => {
    const action = result.ok ? resolve : reject
    return action(result)
  })
}
